import React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import {
  SCORE_DISPLAY,
  SCORE_DISPLAY_OPTIONS,
  SCORE_FORMAT_OPTIONS,
} from '../../constants/director-constants';

/**
 * Configura cómo ven los directores de club sus calificaciones:
 * bloques de color (semáforo), el número, o el número sobre el color.
 */
export const DirectorScoreDisplayEditor = ({ display, format, onDisplayChange, onFormatChange }) => {
  const showsNumber = display !== SCORE_DISPLAY.SEMAFORO;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant='subtitle2' sx={{ fontWeight: 600 }}>
        Calificaciones en el portal del director
      </Typography>

      <TextField
        select
        label='Visualización'
        name='directorScoreDisplay'
        value={display}
        onChange={e => onDisplayChange(e.target.value)}
        helperText='Cómo ve el director la calificación de cada evento y rúbrica.'
        fullWidth
      >
        {SCORE_DISPLAY_OPTIONS.map(opt => (
          <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
        ))}
      </TextField>

      <TextField
        select
        label='Formato del número'
        name='directorScoreFormat'
        value={format}
        onChange={e => onFormatChange(e.target.value)}
        disabled={!showsNumber}
        helperText={showsNumber
          ? 'Formato en que se muestra la puntuación.'
          : 'Sólo aplica cuando la visualización incluye números.'}
        fullWidth
      >
        {SCORE_FORMAT_OPTIONS.map(opt => (
          <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
        ))}
      </TextField>
    </Box>
  );
};
